import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default (
  <Route key="/consumer/features/video-face-swap" element={<DefaultConsumerLayout />}>
    <Route path="consumer/features/video-face-swap" element={<AsyncPage />} />
  </Route>
);
